import { IModelDataV1 } from '@df/catalog/model';


export namespace NUgcImage {
    export const ENDPOINTS = {
        upload: 'ugc/upload'
    };

    export interface IModelData extends IModelDataV1 {
        sku: string;
        product?: number;
        user_tag?: string;
        image: string;
        product_type?: number[];
        priority?: number;
    }

    export interface IUploadData {
        image: File;
        user_tag?: string;
        email_address: string;
        sku?: string;
    }
}
